import type { SubscriptionPlan } from '@billx/types';

import { userApiClient } from '../clients';
import type { NucleusServiceResponse } from './types';
import { handleAxiosError } from './utils';
export class SubscriptionPlanService {
  /**
   * Get all active subscription plans
   */
  static async getActivePlans(): Promise<
    NucleusServiceResponse<SubscriptionPlan[]>
  > {
    try {
      const response = await userApiClient.get('/subscription-plans');

      return response.data;
    } catch (error) {
      return handleAxiosError(error, 'Failed to fetch subscription plans');
    }
  }

  /**
   * Get a specific subscription plan by ID
   */
  static async getPlanById(
    planId: string
  ): Promise<NucleusServiceResponse<SubscriptionPlan>> {
    try {
      const response = await userApiClient.get(`/subscription-plans/${planId}`);

      return response.data;
    } catch (error) {
      return handleAxiosError(error, 'Failed to fetch subscription plan');
    }
  }
}
